/** @format */

import { Icon } from "@ui-library/core"
import { CloseLined } from "@ui-library/icons"
import React from "react"
import {
	ToastContainer,
	Header,
	HeaderTitle,
	CheckIcon,
	ErrorIcon,
	WarningIcon,
	Content,
	CloseButton,
	Footer,
} from "./Toast.styled"

import useToast from "_stores/toast"
import { ToastProgressBar } from "_components/atoms"

export const Toast = () => {
	const { toastState, closeToast } = useToast()

	const { progression } = toastState
	const { headerText, message, type } = toastState.content ?? {
		headerText: "",
		message: "",
		type: "success",
	}

	return (
		<ToastContainer
			type={type}
			displayed={toastState.displayed}
			data-testid="toast-container"
		>
			<Header>
				<HeaderTitle type={type}>
					{type === "success" ? (
						<CheckIcon />
					) : type === "warning" ? (
						<WarningIcon />
					) : (
						<ErrorIcon />
					)}
					{headerText}
				</HeaderTitle>
				<CloseButton onClick={() => closeToast()} role="close" />
			</Header>
			<Content>{message}</Content>
			<Footer>
				<ToastProgressBar kind={type} progression={progression} />
			</Footer>
		</ToastContainer>
	)
}

export default Toast
